import { ShiftLabels } from '@tymbe/schema/shift-template.interface';

export const shiftLabelsText: Record<string, string> = {
  [ShiftLabels.PHYSICALLY_CHALLENGING_JOB]: 'Fyzicky náročná brigáda',
  [ShiftLabels.CZECH_LANGUAGE_REQUIRED]: 'Czech language required',
};

export const transformShiftLabels = (labels: string[]) => labels.map((label) => ({
  label: shiftLabelsText[label] || label,
  value: label,
}));

export const shiftLabelsOptions = transformShiftLabels(Object.keys(shiftLabelsText));
